import { useState, useEffect } from 'react';
import { useCurrentProjectId } from './path-params-extraction.hooks';

export enum PanelType {
  Organization = 'organization',
  Project = 'project'
}

export const usePanelType = (): PanelType => {
  const [panelType, setPanelType] = useState<PanelType>(PanelType.Organization);
  const projectId = useCurrentProjectId();

  useEffect(() => {
    const nextType = !!projectId ? PanelType.Project : PanelType.Organization;
    if (nextType !== panelType) {
      setPanelType(nextType);
    }
  }, [projectId, panelType]);

  return panelType;
};
